import PropTypes from "prop-types"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

export function DateTimeField({
  label,
  value,
  onChange,
  minutesStep = 5,
  minDateTime,
  maxDateTime,
  disabled = false,
  fullWidth = true,
  ...rest
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DateTimePicker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={(newValue) =>
          onChange(newValue ? newValue.toISOString() : "")
        }
        minutesStep={minutesStep}
        minDateTime={minDateTime ? dayjs(minDateTime) : undefined}
        maxDateTime={maxDateTime ? dayjs(maxDateTime) : undefined}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth,
          },
        }}
        timezone="system"
        {...rest}
      />
    </LocalizationProvider>
  );
}

DateTimeField.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.any,
  maxDateTime: PropTypes.any,
  minDateTime: PropTypes.any,
  minutesStep: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.any
}
